import { useNavigate } from "react-router-dom";

export const useBackButtonData = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  return {
    handleBack,
  };
};
